import { useContext, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import "../../../../assets/css/customer/publicCustomerCss/bookinghotel.css";
import AppContext from '../../../../context/AppContext';
import BookingProgress from '../../../../components/customer/PublicCustomerScreens/BookingHotels/BookingProgress';
import GuestInfo from '../../../../components/customer/PublicCustomerScreens/BookingHotels/GuestInfo';
import PricingPayment from '../../../../components/customer/PublicCustomerScreens/BookingHotels/PricingPayment';

const BookingHotel = () => {
const { validateField, baseUrl, authToken } = useContext(AppContext);
const location = useLocation();
const navigate = useNavigate();
const { hotel, room, checkInDate, checkOutDate, nights, totalPrice, resumeStep, formData } = location.state || {};
const [step,    setStep]    = useState(resumeStep  || 1);
const [errors,  setErrors]  = useState({});
const [loading, setLoading] = useState(false);
const customerId = localStorage.getItem('customerId'); 
const [data, setData] = useState({
    guestName:      formData?.guestName      ?? localStorage.getItem('userName'),
    guestEmail:     formData?.guestEmail     ?? (localStorage.getItem('customerEmail') || 'guest@example.com'),
    guestPhone:     formData?.guestPhone     ?? '',
    city:           formData?.city           ?? '',
    numberOfGuests: formData?.numberOfGuests ?? 1,
    checkIn:        checkInDate  || '',
    checkOut:       checkOutDate || '',
    nights:         nights       || 0,
    pricePerNight:  room?.price  || 0,
    totalAmount:    totalPrice || (room?.price || 0) * (nights || 0),
    specialRequests: formData?.specialRequests ?? '',
    agreeTerms:     formData?.agreeTerms ?? false,
});
  useEffect(() => {
    if (!hotel || !room) navigate('/hotels');
  }, [hotel, room, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setData(d => ({ ...d, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateGuestInfo = () => {
    const e = {};
    const nameError  = validateField('name',  data.guestName);
    const phoneError = validateField('phone', data.guestPhone);
    if (nameError)  e.guestName  = nameError;
    if (phoneError) e.guestPhone = phoneError;
    if (!data.city.trim())           e.city           = 'City is required';
    if (data.numberOfGuests < 1)     e.numberOfGuests = 'At least 1 guest required';
    if (data.numberOfGuests > (room?.capacity || 10)) {
     e.numberOfGuests = `Maximum ${room?.capacity || 10} guests allowed for this room`;
     }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const validatePayment = () => {
    const e = {};
    if (!data.agreeTerms) e.agreeTerms = 'Please accept terms & conditions';
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const nextStep = () => {
    if (validateGuestInfo()) { setStep(2); window.scrollTo(0, 0); }
  };

  const prevStep = () => { setStep(1); window.scrollTo(0, 0); };

 const handleSubmit = () => {
    if (!validatePayment()) return;

    setLoading(true);

    const payload = {
      jjcustomer_id:    customerId,
      jjvendor_id:      hotel?.vendorId,
      jjroom_id:        room?.id,
      phone_no:         data.guestPhone,
      cus_city:         data.city,
      booking_type:     'hotel',
      jjpackage_id:     null,
      hotelId:          hotel?.id,
      checkIn:          data.checkIn,
      checkOut:         data.checkOut,
      number_of_guests: data.numberOfGuests,
      total_amount:     data.totalAmount,
      booking_status:   'pending',
    };

    axios
      .post(
        `${baseUrl}/customer/addHotel-booking`,
        payload,
        { headers: { Authorization: `Bearer ${authToken}` } }
      )
      .then((response) => {
        const booking   = response.data?.data || response.data;
        const bookingId = booking?.id || booking?.jjbooking_id;

        if (!bookingId) throw new Error(response.data?.message || 'Booking creation failed.');

        return axios.post(
          `${baseUrl}/customer/payment/checkout`,
          { jjbooking_id: bookingId },
          { headers: { Authorization: `Bearer ${authToken}` } }
        );
      })
      .then((paymentRes) => {
        const stripeUrl = paymentRes.data?.url;
        if (!stripeUrl) throw new Error('Payment session could not be created.');

        localStorage.setItem('lastViewedHotel', hotel?.id);

        window.location.href = stripeUrl;
      })
      .catch((err) => {
        console.error('Booking/Payment error:', err);
        Swal.fire({
          title:              'Error',
          text:               err.message || 'Unable to process. Please try again.',
          icon:               'error',
          confirmButtonColor: '#2C5F7C',
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Container className="hb-hotel-booking-container py-4">
      <BookingProgress currentStep={step} />

      <div className="hb-booking-card bg-white rounded shadow-sm p-4 mt-4">

        {step === 1 && (
          <GuestInfo
            data={data}
            errors={errors}
            handleChange={handleChange}
            nextStep={nextStep}
          />
        )}

        {step === 2 && (
          <PricingPayment
            data={data}
            errors={errors}
            handleChange={handleChange}
            hotel={hotel}
            room={room}
            nights={data.nights}
            totalAmount={data.totalAmount}
            pricePerNight={data.pricePerNight}
            prevStep={prevStep}
            handleSubmit={handleSubmit}   
            loading={loading}
          />
        )}
      </div>
    </Container>
  );
};

export default BookingHotel;